import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    contentWrapper: {
      marginTop: "24px",
      width: "100%",
    },
    settingsForm: {
      padding: "24px 32px",
      [theme.breakpoints.down("600")]: {
        padding: "24px 16px",
      },
    },
    radioGroupLabel: {
      color: "#344054",
      fontSize: "14px",
      minWidth: "280px",
      fontWeight: "600",
      lineHeight: "20px",
      [theme.breakpoints.down("900")]: {
        minWidth: "initial",
      },
    },
    fieldWrapper: {
      gap: "32px",
      alignItems: "flex-start",
      "& + &": {
        borderTop: "1px solid #EAECF0",
        paddingTop: "20px",
        marginTop: "20px",
      },
      [theme.breakpoints.down("900")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
      },
    },
    fieldContainer: {
      display: "flex",
      gap: "10px",
      flexDirection: "column",
      width: "100% !important",
      maxWidth: "512px",
    },
    scoreWrapper: {
      flexDirection: "column",
      gap: "16px",
    },
    scoreContainer: {
      display: "flex",
      gap: "10px",
      width: "100% !important",
      maxWidth: "512px",
      [theme.breakpoints.down("1278")]: {
        flexDirection: "column",
        // gap: "12px",
      },
    },
    subText: {
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      marginTop: "16px",
      color: theme.palette.text.tertiary,
    },

    radioRootWrapper: {
      margin: 0,
    },
    disabled: {
      "&  .MuiInputBase-root": {
        background: "#F9FAFB",
      },
    },
    inputwrapper: {
      width: "100% !important",
      [theme.breakpoints.down("500")]: {
        "& label": {
          minWidth: "auto",
        },
      },
    },
    scoreLabel: {
      fontSize: "14px",
      fontWeight: "500",
    },
    leadDistribution: {
      margin: "0",
      "&  div": {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        margin: "0",
      },
    },
  };
});
